module.exports = __webpack_public_path__ + "static/media/agreement-application-business.e5509072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/agreement-application-business.jpg
// module id = 339
// module chunks = 0